import {h, Component} from 'preact';
export default class Cog extends Component {
    render() {
        return (
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  width="16" height="16" viewBox="0 0 16 16">
                <path fill={this.props.color} d="M16 7l-3.767-0.753 2.131-3.196-1.414-1.414-3.196 2.131-0.753-3.767h-2l-0.753 3.767-3.196-2.131-1.414 1.414 2.131 3.196-3.767 0.753v2l3.767 0.753-2.131 3.196 1.414 1.414 3.196-2.131 0.753 3.767h2l0.753-3.767 3.196 2.131 1.414-1.414-2.131-3.196 3.767-0.753v-2zM8 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"></path>
                <path fill={this.props.color} d="M9 8c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"></path>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./components/SVGImages/Cog.js